import Vue from 'vue';
const resource = '/orderitems';

export default {
  updateQuantity(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/updatequantity`,
      payload
    );
  },
  linkWithWorkOrder(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/linkwithworkorder`,
      payload
    );
  },
};
